import {createAsyncThunk, createEntityAdapter, createSlice} from '@reduxjs/toolkit';
import {toast} from "react-toastify";
import {
    addReturnApi,
    addTrackingApi,
    createTrackingInvoiceApi,
    exportRoyalmainOrdersApi,
    downloadBulkPdfApi,
    downloadInvoiceApi,
    downloadPresentmentInvoiceApi,
    downloadCostPriceInvoiceApi,
    downloadPdfApi,
    downloadVGBarcodePDFApi,
    downloadInvoiceLabelApi,
    downloadTrackingInvoiceApi, exportEvriDataApi, exportNextDayEvriDataApi, generateAllPickingTicketApi, fulfillmentSummaryPickingTicketApi,
    vogaclosetBarcodeApi,
    usLableApi,
    royalMailLabelApi,
    royalMailCustomsApi,
    dpdLabelApi,
    inpostLabelApi,
    bulkDpdLabelsByOrdersApi,
    bulkDpdLabelStatusApi,
    zalandoDELabelApi,
    zalandoPaperworkApi,
    zalandoTbOneFulfillApi,
    generateOrderPdfApi,
    generateOrderShippingDetails,
    generateReturnDetails,
    generateReturnGroupDetails,
    generateVatDetails, getCurrentDeliveryPartnerApi, getLatestPickingTicketApi,
    getOrdersApi,
    getOrderSettingsApi,
    getReturnsApi,
    getReturnRestockApi,
    getTrackingItemApi,
    importDpdFileApi,
    sendReturnItemShopifyApi,
    archiveRefundApi,
    bulkArchiveRefundApi,
    showOrderApi,
    ensureSellerPushApi,
    getSellerPushStatusApi,
    showPendingReturnRequestListApi,
    showAlterationRequestListApi,
    showAlterationRequestApi,
    editAlterationRequestApi,
    updateAlterationRequestApi,
    showPendingReturnReturn,
    viewPendingReturnReturn,
    showReturnApi,
    showReturnListApi,
    showTrackingInvoiceApi,
    exportVogaClosetImportApi,
    exportVogaClosetApi,
    exportSekoApi,
    storePendingReturnRequest, updateDeliveryPartnerApi,
    updatePendingReturnRequest,
    updateDispatchOrderDataApi, generatePendingReturnDetails,generateAlterationRequestDetails,
    importEvriileApi, reassignShippingApi, reassignSellerApi, 
    exportVogaClosetDetailApi,exportVogaClosetNewApi,orderRefundDataApi,
    postReturnsRestockApi,
    generateFilteredDetails,
    getCollabOrdersApi, getCollabOrderApi, approveCollabOrderApi, resendInvoiceCollabOrderApi,
    generateFilteredCollabOrderData,
    addImageCollabOrderApi, deleteImageCollabOrderApi,
    getDirectRefundApi,
    storeDirectRefundApi,
    resendInvoiceReturnFeeReturnRequestApi,
    retryDraftOrderApi,
    resendTrackingEmailApi,
    regenerateTrackingApi,
    syncPaymentStatusApi,
    syncReturnTrackingApi,
    bulkSyncReturnTrackingApi,
    syncAlterationTrackingApi,
    freemansLabelApi,
    freemansDeliveryNoteApi,
    syncOrderTrackingApi,
    getRefundEmailTemplateApi,
    sendRefundEmailApi,
    getOutOfStockEmailTemplateApi,
    sendOutOfStockEmailApi,
    getUnfulfilledOrderStatusApi,
    cancelReturnRequestApi,
    cancelOrderApi,
    claimOfferApi,
    updateClaimOfferApi,
    deleteClaimOfferApi,
    refundReturnFeeApi,
    importDpdManifestedFileApi,
    downloadCreditNoteApi,
    importRoyalmailTrackingApi,
    getGojungoOrdersApi,
    getGojungoOrderApi,
    getGojungoSettingsApi,
    getEuOrdersApi,
    getEuOrderApi,
    downloadAuthenticatedFileApi,
    calculateRefundAllocationApi,
    convertStoreCreditToRefundApi
} from "../../../services/order";
import { sendFrasersReminderApi } from "../../../services/frasersPlus";
import {orderFilters, returnOrderFilters, pendingReturnFilters, returnRestockFilters, collabOrderFilters, alterationRequestFilters} from "../../manage-product/product/edit/content/settings/map";


export const getOrders = createAsyncThunk('orders/getAllOrders', async (data, {dispatch,}) => {
    const response = await getOrdersApi(data);
    dispatch(setTableRowCount(response.response.count));
    dispatch(setOrderStatusSummary(response.response.status_summary))
    return response.response.data;
});


export const showOrder = createAsyncThunk('orders/getOrder', async (data, {dispatch}) => {
    const response = await showOrderApi(data.id,data.params);
    return response.response;
});

export const ensureSellerPush = createAsyncThunk('orders/ensureSellerPush', async (data) => {
    const response = await ensureSellerPushApi(data.id, { seller_id: data.seller_id });
    return response.response;
});

export const getSellerPushStatus = createAsyncThunk('orders/getSellerPushStatus', async (id) => {
    const response = await getSellerPushStatusApi(id);
    return response.response;
});

export const downloadOrderPdf = createAsyncThunk('orders/downloadPdfSlip', async (data, {dispatch}) => {
    const response = await downloadPdfApi(data.id, data.params);
    return response.response;
});

export const downloadVGBarcodePDF = createAsyncThunk('orders/downloadVGBarcodePDF', async (data, {dispatch}) => {
    const response = await downloadVGBarcodePDFApi(data);
    return response.response;
});

export const downloadBulkOrderPdf = createAsyncThunk('orders/downloadBulkPdfSlip', async (data, {dispatch}) => {
    const response = await downloadBulkPdfApi(data);
    return response.response;
});

export const exportRoyalmainOrders = createAsyncThunk('orders/exportRoyalmainOrders', async (data, {dispatch}) => {
    const response = await exportRoyalmainOrdersApi(data);
    return response.response;
});

export const downloadOrderInvoice = createAsyncThunk('orders/downloadInvoice', async (data, {dispatch}) => {
    const response = await downloadInvoiceApi(data.id,data.params);
    return response.response;
});

export const downloadOrderPresentmentInvoice = createAsyncThunk('orders/downloadInvoice', async (data, {dispatch}) => {
    const response = await downloadPresentmentInvoiceApi(data.id,data.params);
    return response.response;
});

export const downloadCostPriceOrderInvoice = createAsyncThunk('orders/downloadCostPriceInvoice', async (data, {dispatch}) => {
    const response = await downloadCostPriceInvoiceApi(data.id,data.params);
    return response.response;
});

export const getOrderSettings = createAsyncThunk('order/getOrderSettings', async () => {
    const response = await getOrderSettingsApi();
    return response.response;
});

export const exportOrderShippingDetails = createAsyncThunk('order/exportShoppingData', async (data, {dispatch}) => {
    const response = await generateOrderShippingDetails(data);
    return response.response;
});

export const exportVatDetails = createAsyncThunk('order/exportVatData', async (data, {dispatch}) => {
    const response = await generateVatDetails(data);
    return response.response;
});

export const generateOrderPdfData = createAsyncThunk('order/generateOrderPdf', async (data, {dispatch}) => {
    const response = await generateOrderPdfApi(data);
    return response.response;
});

export const exportEvriData = createAsyncThunk('order/generateOrderPdf', async (data, {dispatch}) => {
    const response = await exportEvriDataApi(data);
    return response.response;
});

export const exportNextDayEvriData = createAsyncThunk('order/generateOrderPdf', async (data, {dispatch}) => {
    const response = await exportNextDayEvriDataApi(data);
    return response.response;
});

export const sekoExport = createAsyncThunk('order/sekoExport', async (data, {dispatch}) => {
    const response = await exportSekoApi(data);
    return response.response;
});

export const vogaClosetExport = createAsyncThunk('order/vogaClostExport', async (data, {dispatch}) => {
    const response = await exportVogaClosetApi(data);
    return response.response;
});

export const vogaClosetNewExport = createAsyncThunk('order/vogaClostNewExport', async (data, {dispatch}) => {
    const response = await exportVogaClosetNewApi(data);
    return response.response;
});

export const vogaClosetDetailExport = createAsyncThunk('order/vogaClostNewExport', async (data, {dispatch}) => {
    const response = await exportVogaClosetDetailApi(data);
    return response.response;
});


export const exportVogaClosetImport = createAsyncThunk('order/importVogaCloset', async (data, {dispatch}) => {
    const response = await exportVogaClosetImportApi(data);
    return response.response;
});

export const exportFilteredDetails = createAsyncThunk('order/exportFilteredData', async (data, {dispatch}) => {
    const response = await generateFilteredDetails(data);
    return response.response;
});

export const exportCollabOrderFilteredData = createAsyncThunk('order/exportFilteredCollabData', async (data, {dispatch}) => {
    const response = await generateFilteredCollabOrderData(data);
    return response.response;
});

export const sendFrasersReminder = createAsyncThunk('order/sendFrasersReminder', async (orderId, {dispatch}) => {
    const response = await sendFrasersReminderApi(orderId);
    if (response.response.ok) {
        toast.success(response.response.message);
    } else {
        toast.error(response.response.message);
    }
    dispatch(setFrasersReminders(response.response.reminders));
    return response.response;
});

export const cancelOrder = createAsyncThunk('order/cancelOrder', async (data, {dispatch}) => {
    const response = await cancelOrderApi(data);
    return response.response;
});

export const importDpdManifestedData = createAsyncThunk("order/dpdManifestImport", async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await importDpdManifestedFileApi(data);
  
      toast.success("File imported successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
  
      return response;
    } catch (error) {
      const errorData = error?.errors ? error : { is_valid: false, message: "Failed to import file", errors: [] };
  
      dispatch(setDpdManifestedErrorData(errorData));
  
      return rejectWithValue(errorData);
    }
});
  
export const addReturnItems = createAsyncThunk('order/addReturnItems', async (returnItems, {dispatch, getState}) => {
    try {
        const response = await addReturnApi(returnItems);
        const data = await response.response;
        toast.success("Returns added successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return data;
    } catch (e) {

        return Promise.reject(e);
    }
});

export const sendReturnItemShopify = createAsyncThunk('orders/sendReturnItemShopify', async (data, {dispatch}) => {

    try {
        const response = await sendReturnItemShopifyApi(data);
        toast.success(`Return sent to shopify successfully`, {
            position: toast.POSITION.TOP_RIGHT,
        });
        return response.response;
    } catch (e) {
        toast.error("Failed to process request", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return Promise.reject(e);
    }


});

export const archiveRefund = createAsyncThunk('orders/archiveRefund', async (data, {rejectWithValue}) => {
    try {
        const response = await archiveRefundApi(data);
        toast.success("Refund archived successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return response.response;
    } catch (e) {
        return rejectWithValue(typeof e === 'string' ? e : "Failed to archive refund");
    }
});

export const bulkArchiveRefund = createAsyncThunk('orders/bulkArchiveRefund', async (data, {rejectWithValue}) => {
    try {
        const response = await bulkArchiveRefundApi(data);
        if (response.response.archived.length) {
            toast.success(`${response.response.archived.length} refund(s) archived successfully`, {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
        return response.response;
    } catch (e) {
        return rejectWithValue(typeof e === 'string' ? e : "Failed to archive refunds");
    }
});

export const getOutOfStockEmailTemplate = createAsyncThunk('orders/getOutOfStockEmailTemplate', async (data) => {
    const response = await getOutOfStockEmailTemplateApi(data);
    return response.response;
});

export const sendOutOfStockEmail = createAsyncThunk('orders/sendOutOfStockEmail', async (data) => {
    try {
        const response = await sendOutOfStockEmailApi(data);
        toast.success("Out of stock email sent successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return response.response;
    } catch (e) {
        toast.error("Failed to send out of stock email", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return Promise.reject(e);
    }
});

export const getRefundEmailTemplate = createAsyncThunk('orders/getRefundEmailTemplate', async (data) => {
    const response = await getRefundEmailTemplateApi(data);
    return response.response;
});

export const sendRefundEmail = createAsyncThunk('orders/sendRefundEmail', async (data) => {
    try {
        const response = await sendRefundEmailApi(data);
        toast.success("Refund email sent successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return response.response;
    } catch (e) {
        toast.error("Failed to send refund email", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return Promise.reject(e);
    }
});


export const createTrackingInvoice = createAsyncThunk('order/createInvoiceTracking', async (trackingItems, {
    dispatch,
    getState
}) => {
    try {
        const response = await createTrackingInvoiceApi(trackingItems);
        const data = await response.response;
        toast.success("Invoice created successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return data;
    } catch (e) {

        return Promise.reject(e);
    }
});

export const addTrackingItems = createAsyncThunk('order/addTracking', async (trackingItems, {dispatch, getState}) => {
    try {
        const response = await addTrackingApi(trackingItems);
        toast.success(response.response.message, {
            position: toast.POSITION.TOP_RIGHT,
        });

        return response.response;
    } catch (e) {
        toast.error("Failed to process request", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return Promise.reject(e);
    }
});

export const downloadTrackingInvoice = createAsyncThunk('orders/downloadTrackingInvoice', async (id, {dispatch}) => {
    const response = await downloadTrackingInvoiceApi(id);
    return response.response;
});

export const downloadInvoiceLabel = createAsyncThunk('orders/downloadInvoiceLabel', async (id) => {
    const response = await downloadInvoiceLabelApi(id);
    return response.response;
});

export const downloadAuthenticatedFile = createAsyncThunk('orders/downloadAuthenticatedFile', async (url, {rejectWithValue}) => {
    try {
        const response = await downloadAuthenticatedFileApi(url);
        return response.response;
    } catch (e) {
        const responseData = e?.response?.data;
        if (responseData instanceof Blob) {
            try {
                const text = await responseData.text();
                const json = JSON.parse(text);
                return rejectWithValue(json);
            } catch (_) {
                return rejectWithValue({ error: "Failed to download file" });
            }
        }
        return rejectWithValue({ error: e?.response?.data?.error || "Failed to download file" });
    }
});

export const showTrackingInvoice = createAsyncThunk('orders/getTrackingInvoice', async (id, {dispatch}) => {
    const response = await showTrackingInvoiceApi(id);
    return response.response;
});

export const getTrackingItem = createAsyncThunk('orders/getOrderPacking', async (id, {dispatch,}) => {
    const response = await getTrackingItemApi(id);
    return response.response;
});

export const returnRestock = createAsyncThunk('orders/returnRestock', async (data, {dispatch}) => {
    const response = await postReturnsRestockApi(data);
    toast.success(response.response, {
        position: toast.POSITION.TOP_RIGHT,
    });
    return response.response;
});

export const getReturns = createAsyncThunk('orders/getAllReturns', async (data, {dispatch,}) => {
    const response = await getReturnsApi(data);
    dispatch(setTableRowCount(response.response.count));
    return response.response.data;
});

export const getReturnRestockList = createAsyncThunk('orders/getAllReturnRestock', async (data, {dispatch,}) => {
    const response = await getReturnRestockApi(data);
    dispatch(setTableRowCount(response.response.count));
    return response.response.data;
});

export const showReturnList = createAsyncThunk('orders/getReturnList', async (id, {dispatch}) => {
    const response = await showReturnListApi(id);
    return response.response;
});

export const showReturn = createAsyncThunk('orders/getReturn', async (data, {dispatch}) => {
    const response = await showReturnApi(data.id, data.params);
    return response.response;
});

export const exportReturnDetails = createAsyncThunk('order/exportReturnData', async (data, {dispatch}) => {
    const response = await generateReturnDetails(data);
    return response.response;
});

export const exportReturnGroupDetails = createAsyncThunk('order/exportReturnData', async (data, {dispatch}) => {
    const response = await generateReturnGroupDetails(data);
    return response.response;
});

export const getAllPendingReturnRequest = createAsyncThunk('orders/getAllPendingReturnRequest', async (data, {dispatch,}) => {

    const response = await showPendingReturnRequestListApi(data);
    dispatch(setTableRowCount(response.response.count));
    dispatch(setCustomerReturnReasons(response.response.return_reasons));    
    dispatch(setReturnRequestData(response.response));
    return response.response.data;
});

export const getAllAlterationRequest = createAsyncThunk('orders/getAllAlterationRequest', async (data, {dispatch,}) => {
    const response = await showAlterationRequestListApi(data);
    dispatch(setAlterationRequest(response.response));
    return response.response;
});

export const editAlterationRequest = createAsyncThunk('orders/editAlterationRequest', async (data, {dispatch}) => {
    const response = await editAlterationRequestApi(data.id, data.params);
    dispatch(setAlterationRequestData(response.response));
    return response.response;
});

export const updateAlterationRequest = createAsyncThunk('orders/updateAlterationRequest', async (data, {dispatch}) => {
    const response = await updateAlterationRequestApi(data);
    toast.success(response.response.message, {
        position: toast.POSITION.TOP_RIGHT,
    });
    return response.response;
});

export const showAlterationRequest = createAsyncThunk('orders/showAlterationRequest', async (data, {dispatch}) => {
    const response = await showAlterationRequestApi(data.id, data.params);
    dispatch(setAlterationRequestData(response.response));
    return response.response;
});

export const showPendingReturnRequestList = createAsyncThunk('orders/getPendingReturnReturn', async (data, {dispatch}) => {
    const response = await showPendingReturnReturn(data.id, data.params);
    dispatch(setPendingReturnData(response.response));
    return response.response;
});

export const viewPendingReturnRequestList = createAsyncThunk('orders/getPendingReturnReturn', async (data, {dispatch}) => {
    const response = await viewPendingReturnReturn(data.id, data.params);
    dispatch(setPendingReturnData(response.response));
    return response.response;
});

export const resendTrackingEmail = createAsyncThunk('orders/resendTrackingEmail', async (data, {dispatch}) => {
    const response = await resendTrackingEmailApi(data);
    toast.success(response.response, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
    });
    return response.response;
});

export const regenerateTracking = createAsyncThunk('orders/regenerateTracking', async (data, {dispatch}) => {
    const response = await regenerateTrackingApi(data);
    toast.success(response.response, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
    });
    return response.response;
});

export const syncPaymentStatus = createAsyncThunk('orders/syncPaymentStatus', async (data, {dispatch}) => {
    const response = await syncPaymentStatusApi(data);
    toast.success(response.response, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
    });
    return response.response;
});

export const resendInvoiceReturnFeeReturnRequest = createAsyncThunk('orders/resendInvoiceReturnFeeReturnRequest', async (data, {dispatch}) => {
    const response = await resendInvoiceReturnFeeReturnRequestApi(data.id, data);
    dispatch(setPendingReturnData(response.response));
    toast.success("Invoice resent successfully", {
        position: toast.POSITION.TOP_RIGHT,
    });
    return response.response;
});

export const retryDraftOrder = createAsyncThunk('orders/retryDraftOrder', async (id, { rejectWithValue }) => {
    try {
        const { response } = await retryDraftOrderApi(id);
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data);
    }
});

export const syncReturnTracking = createAsyncThunk('orders/syncReturnTracking', async (data, {dispatch}) => {
    const response = await syncReturnTrackingApi(data);
    toast.success(response.response, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
    });
    return response.response;
});

export const bulkSyncReturnTracking = createAsyncThunk('orders/bulkSyncReturnTracking', async (data, {dispatch}) => {
    const response = await bulkSyncReturnTrackingApi(data);
    return response.response;
});

export const syncAlterationTracking = createAsyncThunk('orders/syncAlterationTracking', async (data, {dispatch}) => {
    const response = await syncAlterationTrackingApi(data);
    toast.success(response.response, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
    });
    return response.response;
});

export const syncOrderTracking = createAsyncThunk('orders/syncOrderTracking', async (data, {dispatch}) => {
    const response = await syncOrderTrackingApi(data);
    toast.success(response.response, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
    });
    return response.response;
});

export const updateDispatchOrderData = createAsyncThunk('order/updateDispatchOrderData', async (data, {dispatch}) => {
    const response = await updateDispatchOrderDataApi(data);
    toast.success(response.response, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
    });
    return response.response;
});

export const importDpdData = createAsyncThunk('order/getSelectedOrderData', async (data, {dispatch}) => {
    const response = await importDpdFileApi(data);
    toast.success("File imported successfully", {
        position: toast.POSITION.TOP_RIGHT,
    });
    return response.response;
});
export const importEvriData = createAsyncThunk('order/everiImport', async (data, {dispatch}) => {
    const response = await importEvriileApi(data);
    toast.success("File imported successfully", {
        position: toast.POSITION.TOP_RIGHT,
    });
    return response.response;
});

export const updateDeliveryPartner = createAsyncThunk('order/updateDeliveryPartner', async (data, {dispatch}) => {
    const response = await updateDeliveryPartnerApi(data);
    toast.success("Updated Successfully", {
        position: toast.POSITION.TOP_RIGHT,
    });
    return response.response;
});
export const getCurrentDeliveryPartner = createAsyncThunk('order/getCurrentDeliveryPartner', async (data, {dispatch}) => {
    const response = await getCurrentDeliveryPartnerApi(data);
    return response.response;
});

export const storeReturnRequest = createAsyncThunk('orders/storePendingReturnRequest', async (data, {dispatch}) => {
    try {
        const response = await storePendingReturnRequest(data);
        toast.success(`Return Request updated successfully`, {
            position: toast.POSITION.TOP_RIGHT,
        });
        return response.response;
    } catch (e) {
        toast.error("Failed to process request", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return Promise.reject(e);
    }
});

export const updateReturnRequest = createAsyncThunk('orders/updatePendingReturnRequest', async (data, {dispatch}) => {
    try {
        const response = await updatePendingReturnRequest(data);
        toast.success(`Return Request updated successfully`, {
            position: toast.POSITION.TOP_RIGHT,
        });
        return response.response;
    } catch (e) {
        toast.error("Failed to process request", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return Promise.reject(e);
    }
});

export const convertStoreCreditToRefund = createAsyncThunk('orders/convertStoreCreditToRefund', async (data, {rejectWithValue}) => {
    try {
        const response = await convertStoreCreditToRefundApi(data);
        toast.success(`Store credit converted to refund successfully`, {
            position: toast.POSITION.TOP_RIGHT,
        });
        return response.response;
    } catch (e) {
        // api.jsx already toasts 422s and rejects with the backend's message string; pass it on for inline display.
        return rejectWithValue(typeof e === 'string' ? e : (e?.response?.data?.message || e?.message || 'Failed to convert store credit to refund'));
    }
});

export const generateAllPickingTicket = createAsyncThunk('orders/generateAllPickingTicket', async (data, {dispatch,}) => {
    const response = await generateAllPickingTicketApi(data);
    return response.response;
});

export const fulfillmentSummaryPickingTicket = createAsyncThunk('orders/fulfillmentSummaryPickingTicket', async (data, {dispatch,}) => {
    const response = await fulfillmentSummaryPickingTicketApi(data);
    return response.response;
});

export const vogaclosetBarcode = createAsyncThunk('orders/vogaclosetBarcode', async (data, {dispatch,}) => {
    const response = await vogaclosetBarcodeApi(data);
    return response.response;
});

export const usLabel = createAsyncThunk('orders/usLabel', async (data, {dispatch,}) => {
    const response = await usLableApi(data);
    return response.response;
});

export const royalMailLabel = createAsyncThunk('orders/royalMailLabel', async (data, {dispatch,}) => {
    const response = await royalMailLabelApi(data);
    return response.response;
});

export const royalMailCustoms = createAsyncThunk('orders/royalMailCustoms', async (data, {dispatch,}) => {
    const response = await royalMailCustomsApi(data);
    return response.response;
});

export const dpdLabel = createAsyncThunk('orders/dpdLabel', async (data, {dispatch,}) => {
    const response = await dpdLabelApi(data);
    return response.response;
});

export const inpostLabel = createAsyncThunk('orders/inpostLabel', async (data, {dispatch,}) => {
    const response = await inpostLabelApi(data);
    return response.response;
});

// error.response.data.message covers the backend's own messages (422 empty/invalid input,
// 404 expired/unknown run key); error.message is the fallback for anything else (network, 500).
const extractBulkDpdLabelErrorMessage = (error, fallback) =>
    error?.response?.data?.message || error?.message || fallback;

export const startBulkDpdLabels = createAsyncThunk('orders/startBulkDpdLabels', async (orderNumbers, {rejectWithValue}) => {
    try {
        const response = await bulkDpdLabelsByOrdersApi({order_numbers: orderNumbers});
        return response.response;
    } catch (error) {
        return rejectWithValue({
            message: extractBulkDpdLabelErrorMessage(error, 'Failed to start bulk DPD label generation.'),
        });
    }
});

export const pollBulkDpdLabelStatus = createAsyncThunk('orders/pollBulkDpdLabelStatus', async (runKey, {rejectWithValue}) => {
    try {
        const response = await bulkDpdLabelStatusApi(runKey);
        return response.response;
    } catch (error) {
        return rejectWithValue({
            status: error?.response?.status,
            message: extractBulkDpdLabelErrorMessage(error, 'Failed to check bulk DPD label run status.'),
        });
    }
});

export const zalandoDELabel = createAsyncThunk('orders/zalandoDELabel', async (data, {dispatch,}) => {
    const response = await zalandoDELabelApi(data);
    return response.response;
});

export const zalandoPaperwork = createAsyncThunk('orders/zalandoPaperwork', async (data, {dispatch,}) => {
    const response = await zalandoPaperworkApi(data);
    return response.response;
});

export const zalandoTbOneFulfill = createAsyncThunk('orders/zalandoTbOneFulfill', async (data, {dispatch,}) => {
    const response = await zalandoTbOneFulfillApi(data);
    return response.response;
});

export const freemansLabel = createAsyncThunk('orders/freemansLabel', async (data, {dispatch,}) => {
    const response = await freemansLabelApi(data);
    return response.response;
});

export const freemansDeliveryNote = createAsyncThunk('orders/freemansDeliveryNote', async (data, {dispatch,}) => {
    const response = await freemansDeliveryNoteApi(data);
    return response.response;
});

export const exportPendingReturnDetails = createAsyncThunk('order/exportPendingReturnDetails', async (data, {dispatch}) => {
    const response = await generatePendingReturnDetails(data);
    return response.response;
});

export const exportAlterationRequests = createAsyncThunk('order/exportAlterationRequests', async (data, {dispatch}) => {
    const response = await generateAlterationRequestDetails(data);
    return response.response;
});

export const getLatestPickingTicket = createAsyncThunk('orders/getLatestTicket', async (id, {dispatch}) => {
    const response = await getLatestPickingTicketApi();
    return response.response;
});

export const reassignShipping = createAsyncThunk('orders/reassignShipping', async (data, {dispatch}) => {
    const response = await reassignShippingApi(data);
    toast.success("Updated Successfully", {
        position: toast.POSITION.TOP_RIGHT,
    });
    return response.response;
});

export const orderRefundData = createAsyncThunk('orders/orderRefundData', async (data, {dispatch}) => {
    const response = await orderRefundDataApi(data.id);
    return response.response;
});

export const reassignSeller = createAsyncThunk('orders/reassignSeller', async (data, {dispatch}) => {
    const response = await reassignSellerApi(data);
    toast.success("Updated Successfully", {
        position: toast.POSITION.TOP_RIGHT,
    });
    return response.response;
});

export const getCollabOrders = createAsyncThunk('orders/getAllCollabOrders', async (data, {dispatch}) => {
    const response = await getCollabOrdersApi(data);
    dispatch(setCollabOrders(response.response));
    return response.response.data;
});

export const getCollabOrder = createAsyncThunk('orders/getCollabOrder', async (id, {dispatch}) => {
    const response = await getCollabOrderApi(id);
    dispatch(setCollabOrder(response.response));
    dispatch(setDeclineSettings(response.response.decline_reasons));
    return response.response;
});

export const addImageCollabOrder = createAsyncThunk('addImageCollabOrder', async (imageData, {dispatch, getState}) => {
    try {
        const formData = new FormData();
        // formData.append('shopify_product_id', imageData.shopify_product_id);
        (imageData.image).map((item, i) => {
            formData.append(
                'file[' + i + ']',
                item
            );
        });

        const response = await addImageCollabOrderApi(imageData.order_id, formData);
        const data = response.response;
        toast.success("Image uploaded successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return data;
    } catch (e) {
        console.log(e);
        return Promise.reject(e);
    }
});

export const deleteImageCollabOrder = createAsyncThunk('deleteImageCollabOrder', async (data, {dispatch, getState}) => {
    try {
        const response = await deleteImageCollabOrderApi(data.order_id, data.id);
        toast.success("Image deleted successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return response.response;
    } catch (e) {
        console.error(e);
        return Promise.reject(e);
    }
});

export const approveCollabOrder = createAsyncThunk('orders/approveCollabOrder', async (data, {dispatch}) => {
    const response = await approveCollabOrderApi(data.order_id, data);
    dispatch(setCollabOrderData(response.response));
    return response.response;
});

export const resendInvoiceCollabOrder = createAsyncThunk('orders/resendInvoiceCollabOrder', async (data, {dispatch}) => {
    const response = await resendInvoiceCollabOrderApi(data.order_id, data);
    dispatch(setCollabOrderData(response.response));
    toast.success("Invoice resent successfully", {
        position: toast.POSITION.TOP_RIGHT,
    });
    return response.response;
});

export const getUnfulfilledOrderStatus = createAsyncThunk('order/getUnfulfilledOrderStatus', async (data, {dispatch}) => {
    const response = await getUnfulfilledOrderStatusApi(data);
    dispatch(setUnfulfillmentStatus(response.response))
    return response.response;
});

// Start - Direct Order Refund
export const getDirectRefund = createAsyncThunk('orders/getDirectRefund', async (orderId, {dispatch}) => {
    const response = await getDirectRefundApi(orderId);
    return response.response;
});

export const refundReturnFee = createAsyncThunk('orders/getDirectRefund', async (data, {dispatch}) => {
    const response = await refundReturnFeeApi(data);
    return response.response;
});

export const storeDirectRefund = createAsyncThunk('order/storeDirectRefund', async (data, {dispatch}) => {
    const response = await storeDirectRefundApi(data.order_id, data);
    toast.success(response.response.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
    });
    return response.response;
});
// End - Direct Order Refund

export const cancelReturnRequest = createAsyncThunk('order/cancelReturnRequest', async (data, {dispatch}) => {
    const response = await cancelReturnRequestApi(data);
    
    toast.success(response.response.original.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
    });
    return response.response;
});

export const claimOffer = createAsyncThunk('orders/reassignShipping', async (data, {dispatch, rejectWithValue}) => {
    try {
        const response = await claimOfferApi(data.id, data);
        toast.success("Claim created successfully");
        return response.response;

    } catch (error) {
        const message = error?.response?.data?.message || "Something went wrong";
        toast.error(message);
        return rejectWithValue(message);
    }
});

export const updateClaimOffer = createAsyncThunk('orders/updateClaimOffer', async (data, {dispatch, rejectWithValue }) => {
    try {

        const response = await updateClaimOfferApi(data.id, data);

        toast.success(response.response.message);

        return response.response;

    } catch (error) {

        const message = error?.response?.data || "Something went wrong";

        toast.error(message);

        return rejectWithValue(message);
    }
});

export const deleteClaimOffer = createAsyncThunk('orders/deleteClaimOffer', async (id, {dispatch, rejectWithValue }) => {
    try {

        const response = await deleteClaimOfferApi(id);

        toast.success(response.response.message);

        return response.response;

    } catch (error) {

        const message = error?.response?.data || "Something went wrong";

        toast.error(message);

        return rejectWithValue(message);
    }
});

export const downloadCreditNote = createAsyncThunk('orders/downloadCreditNote', async (data, {dispatch}) => {
    const response = await downloadCreditNoteApi(data.id,data.params);
    return response.response;
});

export const importRoyalmailTracking = createAsyncThunk('orders/importRoyalmailTracking', async (data, {dispatch})=>{
    try {
        const response = await importRoyalmailTrackingApi(data);
        return response.response;
    } catch (e) {
        toast.error(e.message, {
            position: toast.POSITION.TOP_RIGHT,
        });
        return e;
    }
});

export const getGojungoOrders = createAsyncThunk('orders/getGojungoOrders', async (data, {dispatch,}) => {
    const response = await getGojungoOrdersApi(data);
    dispatch(setGojungoData(response.response));
    return response.response;
});

export const getGojungoOrder = createAsyncThunk('orders/getGojungoOrder', async ({ id, displayCurrency }) => {
    const response = await getGojungoOrderApi(id, displayCurrency ? { display_currency: displayCurrency } : undefined);
    return response.response;
});

export const getGojungoSettings = createAsyncThunk('order/getGojungoSettings', async () => {
    const response = await getGojungoSettingsApi();
    return response.response;
});

export const getEuOrders = createAsyncThunk('orders/getEuOrders', async (data, { dispatch }) => {
    const response = await getEuOrdersApi(data);
    dispatch(setEuData(response.response));
    return response.response;
});

export const getEuOrder = createAsyncThunk('orders/getEuOrder', async (id) => {
    const response = await getEuOrderApi(id);
    return response.response;
});

export const calculateRefundAllocation = createAsyncThunk( 'order/calculateRefundAllocation', async (data) => {
    const response = await calculateRefundAllocationApi(data);
    return response.response;

});

const ordersAdapter = createEntityAdapter({});
const checkoutAdapter = createEntityAdapter({});

export const {selectAll: selectOrder, selectById: selectOrderById} = ordersAdapter.getSelectors(
    state => state.order.order
);

export const {selectAll: selectCheckouts, selectById: selectCheckoutById} = checkoutAdapter.getSelectors(
    state => state.order.checkout
);

const orderSlice = createSlice({
    name: 'orders',
    initialState: ordersAdapter.getInitialState({
        id: null,
        orderTableRow: 0,
        checkoutTableRow: 0,
        gojungoTableRow: 0,
        searchText: '',
        customerReturnReasons: [],
        settings: {
            returnReasons: [],
            countries: [],
            deliveryPartners: [],
            shippingType: [],
            brands: [],
            exchangeTypes: [],
            refundStatus: [],
            returnReasonsCustomer:[],
            partner: [],
            tags: [],
        },
        data: null,
        frasersReminders: [],
        collabOrders: [],
        collabOrderData: null,
        collabOrderTableRow: 0,
        decline_reasons: [],
        invoice_data: [],
        refunds: [],
        refund_items: [],
        refund_balance_details: {
            balance_shipping_rate: 0,
            balance_shipping_rate_format: "0.00",
            balance_refund: 0,
            balance_refund_format: "0.00"
        },
        tracking: null,
        selectedInvoiceID: null,
        commissionData: null,
        latestPickingTickets:[],
        newInvoiceDialog: {
            component: 'Invoice',
            type: 'new',
            props: {
                open: false
            },
            data: null
        },
        addTrackingDialog: {
            component: 'Tracking',
            type: 'new',
            props: {
                open: false
            },
            data: null
        },
        refundModal: {
            props: {
                open: false
            },
            data: null
        },
        refundReturnFeeModal: {
            props: {
                open: false
            },
            id:null,
            data: null,
            customerOrder : null,
            orderLineItems:null
        },
        actionDialog: {
            component: 'Action',
            type: 'new',
            props: {
                open: false
            },
            data: null,
            modalType: 0
        },
        importRoyalmailTrackingDialog:{
            title:'',
            type: 1,
            props: {
                isOpen: false,
            },
            data: null
        },
        pickingTicketDialogs:{
            props: {
                isOpen: false
            },
        },
        returnData: null,
        returnRequestData: null,
        returnRequestStatusSummary: null,
        returnRequestTrackingStatusSummary: null,
        pendingReturnData: {
            data: null,
            customOrder: null,
            lists: [],
            sellers: [],
            refundedBy:null,
            trackingLogs: [],
            onItemWithSubcription : false,
        },
        alterationRequestData: {
            data: null,
            lists: [],
            edit_lists: [],
            status_items: []
        },
        alterationRequestLists: [],
        alterationRequestTableRow: 0,
        list: [],
        tracking_list: null,
        trackingDetails: null,
        filter: orderFilters(),
        filters: returnOrderFilters(),
        restockFilters: returnRestockFilters(),
        pendingFilters: pendingReturnFilters(),
        alterationFilters: alterationRequestFilters(),
        collabFilters: collabOrderFilters(),
        currentDeliveryPartner: [],
        currentDeliveryPartners: [],
        deliverPartner:[],
        refundDetail: {
            id:'',
            OrderFundQuantity:'',
            customerReturnQuantity:'',
            sellerReturnQuantity:'',
            order_id: '',
            return_total: '',
            seller: '',
            status: '',
            sku:'',
            return_date: '',
            status_date: '',  
            type: '',
            is_restock:'', 
            is_declined: '',
            order_name: '',
            order_refund_next: '',
            order_refund_prev:'' 
        },
        alterationTrackingDialog: {
            component: 'Tracking',
            type: 'new',
            props: {
                isOpen: false
            },
            data: null
        },
        orderStatusSummary: null,
        alterationStatusSummary : null,
        unfulfillmentStatus : {
            data : [],
            count: 0,
            is_unfulfillment_order : false
        },
        invoiceSales :[],
        invoiceReturns :[],
        addOrderCancelDialog: {
            component: 'OrderCancel',
            type: 'new',
            props: {
                open: false
            },
            data: null
        },
        claimOfferDialog: {
            component: 'ClaimOffer',
            type: 'new',
            props: {
                open: false
            },
            data: null,
            isEdit: false
        },
        DpdManifestedError: null,
        gojungoData : [],
        gojungoSettings: {
            channels: [],
            tenants: [],
            currency: [],
            shipCountries: []
        },
        euData: [],
        euTableRow: 0,
    }),
    reducers: {
        setSettings: (state, action) => {
            // state.setting= action.payload.settings;
            state.settings.returnReasons = action.payload.returnReasons.admin;
            state.settings.returnReasonsCustomer = action.payload.returnReasons.customer;
            state.settings.returnReasonsWarehouse = action.payload.returnReasons.warehouse;
            state.settings.countries = action.payload.countries;
            state.settings.deliveryPartners = action.payload.deliveryPartners;
            state.settings.shippingType = action.payload.shippingType;
            state.settings.brands = action.payload.brands;
            state.settings.exchangeTypes = action.payload.exchangeTypes;
            state.settings.refundStatus = action.payload.refundStatus;
            state.settings.partner = action.payload.partner;
            state.settings.tags = action.payload.tags ?? [];
        },
        setFrasersReminders: (state, action) => {
            state.frasersReminders = action.payload || [];
        },
        setOrderData: (state, action) => {
            if (action.payload.data !== undefined) state.data = action.payload.data;
            if (action.payload.frasers_plus_reminders !== undefined) state.frasersReminders = action.payload.frasers_plus_reminders;
            if (action.payload.list !== undefined) state.list = action.payload.list;
            if (action.payload.tracking_list !== undefined) state.tracking_list = action.payload.tracking_list;
            if (action.payload.tracking !== undefined) state.trackingDetails = action.payload.tracking ? action.payload.tracking : null;
            if (action.payload.address !== undefined) state.address = action.payload.address;
            if (action.payload.deliverPartner !== undefined) state.deliverPartner = action.payload.deliverPartner;
            if (action.payload.refund_balance_details !== undefined) state.refund_balance_details = action.payload.refund_balance_details;
            if (action.payload.has_refunded_items !== undefined) state.has_refunded_items = action.payload.has_refunded_items;
            if (action.payload.refunded_items_count !== undefined) state.refunded_items_count = action.payload.refunded_items_count;
            if (action.payload.has_direct_refund !== undefined) state.has_direct_refund = action.payload.has_direct_refund;
            if (action.payload.can_show_credit_note !== undefined) state.can_show_credit_note = action.payload.can_show_credit_note;

            state.tracking = null;
        },
        setOrderTrackingDetils : (state, action) => {
            if (action.payload.tracking_list !== undefined) state.tracking_list = action.payload.tracking_list;
            if (action.payload.tracking !== undefined) state.trackingDetails = action.payload.tracking ? action.payload.tracking : null;
        },
        setCollabOrders: (state, action) => {
            state.collabOrders = action.payload.data;
            state.collabOrderTableRow = action.payload.count;
        },
        setCollabOrder: (state, action) => {
            state.data = action.payload.data;
            state.list = action.payload.list;
            state.collabOrderData = action.payload.collab_order;
        },
        setDeclineSettings: (state, action) => {
            state.decline_reasons = action.payload;
        },
        setCollabOrderData: (state, action) => {
            state.collabOrderData = action.payload;
        },
        setReturnOrderData: (state, action) => {
            if (action.payload.data !== undefined) state.data = action.payload.data;
            if (action.payload.invoice_data !== undefined) state.invoice_data = action.payload.invoice_data;
            if (action.payload.list !== undefined) state.list = action.payload.list;
            if (action.payload.refunds !== undefined) state.refunds = action.payload.refunds;
            if (action.payload.refund_items !== undefined) state.refund_items = action.payload.refund_items;
            state.exchange_order_details = action.payload.exchange_order_details;          
            state.reference_detail = action.payload.reference_detail;
            state.has_pending_items = action.payload.has_pending_items;
        },
        setRefundsData: (state, action) => {
            if (action.payload.data !== undefined) state.data = action.payload.data;
            if (action.payload.invoice_data !== undefined) state.invoice_data = action.payload.invoice_data;
            if (action.payload.list !== undefined) state.list = action.payload.list;
            if (action.payload.refunds !== undefined) state.refunds = action.payload.refunds;
            if (action.payload.refund_balance_details !== undefined) state.refund_balance_details = action.payload.refund_balance_details;
        },
        setPandingReturnData: (state, action) => {
            if (action.payload.data !== undefined) state.pendingReturnData = action.payload.data;
            if (action.payload.list !== undefined) state.pendingReturnItems = action.payload.list;
        },
        setTrackingData: (state, action) => {
            state.tracking = action.payload;
        },
        unSetTrackingData: (state, action) => {
            state.tracking = null;
        },
        setDpdManifestedErrorData: (state, action) => {
            state.DpdManifestedError = action.payload;
        },
        setReturnData: (state, action) => {
            state.returnData = action.payload;
        },
        setTableRowCount: (state, action) => {
            state.orderTableRow = action.payload;
        },
        setCustomerReturnReasons: (state, action) => {
            state.customerReturnReasons = action.payload
        },
        setOrderListPackQty: (state, action) => {
            // state.list[action.payload.index].pack=action.payload.pack;
        },
        setRefundModal: (state, action) => {
            state.refundModal=action.payload;
        },
        openNewInvoiceDialog: (state, action) => {
            state.newInvoiceDialog = {
                component: 'Invoice',
                type: 'new',
                props: {
                    isOpen: true
                },
                data: null
            };
        },
        closeNewInvoiceDialog: (state, action) => {
            state.newInvoiceDialog = {
                component: 'Invoice',
                type: 'new',
                props: {
                    isOpen: false,
                },
                data: null
            };
        },
        openNewTrackingDialog: (state, action) => {
            state.addTrackingDialog = {
                component: 'Tracking',
                type: 'edit',
                props: {
                    isOpen: true
                },
                data: action.payload
            };
        },
        closeNewTrackingDialog: (state, action) => {
            state.addTrackingDialog = {
                component: 'Tracking',
                type: 'new',
                props: {
                    isOpen: false,
                },
                data: null
            };
            state.selectedInvoiceID = null;
        },
        setReturnRequestData: (state, action) => {
            state.returnRequestData = action.payload.data;
            state.returnRequestStatusSummary = action.payload.status_summary;
            // state.returnRequestTrackingStatusSummary = action.payload.tracking_status_summary;
        },
        setAlterationRequest: (state, action) => {
            state.alterationRequestLists = action.payload.data;
            state.alterationRequestTableRow = action.payload.count;
            state.alterationStatusSummary = action.payload.status_summary;
        },
        setPendingReturnData: (state, action) => {
            if (action.payload.data !== undefined) state.pendingReturnData.data = action.payload.data;
            if (action.payload.lists !== undefined) state.pendingReturnData.lists = action.payload.lists;
            if (action.payload.customOrder !== undefined) state.pendingReturnData.customOrder = action.payload.customOrder;
            if (action.payload.sellers !== undefined) state.pendingReturnData.sellers = action.payload.sellers;
            if (action.payload.deliverPartner !== undefined) state.deliverPartner = action.payload.deliverPartner;
            if (action.payload.refunded_by_user !== undefined) state.pendingReturnData.refundedBy = action.payload.refunded_by_user;
            if (action.payload.tracking_logs !== undefined) state.pendingReturnData.trackingLogs = action.payload.tracking_logs;
            if (action.payload.onItemWithSubcription !== undefined) state.pendingReturnData.onItemWithSubcription = action.payload.onItemWithSubcription;
        },
        setAlterationRequestData: (state, action) => {
            if (action.payload.data !== undefined) state.alterationRequestData.data = action.payload.data;
            if (action.payload.lists !== undefined) state.alterationRequestData.lists = action.payload.lists;
            if (action.payload.edit_lists !== undefined) state.alterationRequestData.edit_lists = action.payload.edit_lists;
            if (action.payload.status_items !== undefined) state.alterationRequestData.status_items = action.payload.status_items;
            if (action.payload.deliverPartner !== undefined) state.deliverPartner = action.payload.deliverPartner;
        },
        setOrderFilter: (state, action) => {
            state.filter = action.payload
        },
        setReturnOrderFilter: (state, action) => {
            state.filters = action.payload
        },
        setReturnRestockFilter: (state, action) => {
            state.restockFilters = action.payload
        },
        setPendingReturnFilter: (state, action) => {
            state.pendingFilters = action.payload
        },
        setAlterationRequestFilter: (state, action) => {
            state.alterationFilters = action.payload
        },
        openActionDialog: (state, action) => {
            state.actionDialog = {
                component: 'Action',
                type: 'new',
                props: {
                    isOpen: true
                },
                data: null,
                modalType: action.payload.dat.type
            };
        },
        closeActionDialog: (state, action) => {
            state.actionDialog = {
                component: 'Action',
                type: 'new',
                props: {
                    isOpen: false
                },
                data: null,
            };
        },
        setCurrentDeliveryPartner: (state, action) => {
            state.currentDeliveryPartner = action.payload
        },
        setCurrentDeliveryPartners: (state, action) => {
            state.currentDeliveryPartners = action.payload
        },
        openPickingTicketDialogs: (state, action) => {
            state.pickingTicketDialogs = {
                props: {
                    isOpen: action.payload
                },
            };
        },
        setLatestPickingTickets: (state, action) => {
            state.latestPickingTickets = action.payload
        },
        setRefundData: (state, action) => {
            state.refundDetail = action.payload;
        },
        setCollabOrderFilter: (state, action) => {
            state.collabFilters = action.payload
        },
        openAlterationTrackingDialog: (state, action) => {
            state.alterationTrackingDialog.props.isOpen = action.payload;
        },
        setOrderStatusSummary : (state, action) => {
            state.orderStatusSummary = action.payload;
        },
        setUnfulfillmentStatus: (state, action) => {
            state.unfulfillmentStatus.data = action.payload.data;
            state.unfulfillmentStatus.count = action.payload.count;
            state.unfulfillmentStatus.is_unfulfillment_order = action.payload.is_unfulfillment_order;
        },
        setInvoiceSalesReturnData: (state, action) => { 
            state.invoiceSales = action.payload.sale;
            state.invoiceReturns = action.payload.returns;
        },
        openOrderCancelDialog: (state, action) => {
            state.addOrderCancelDialog = {
                component: 'OrderCancel',
                type: 'new',
                props: {
                    isOpen: true
                },
                id:action.payload,
                data:null
            };
        },
        closeOrderCancelDialog: (state, action) => {
            state.addOrderCancelDialog = {
                type: 'OrderCancel',
                props: {
                    isOpen: false
                },
                id:"",
                data: null
            };
        },
        openNewClaimOfferDialog: (state, action) => {
            state.claimOfferDialog = {
                component: 'ClaimOffer',
                type: 'new',
                props: {
                    isOpen: true
                },
                data: action.payload.row,
                isEdit: action.payload.isEdit
            };
        },
        closeNewClaimOffeDialog: (state, action) => {
            state.claimOfferDialog = {
                component: 'ClaimOffer',
                type: 'new',
                props: {
                    isOpen: false,
                },
                data: null
            };
        },
        openRefundReturnFeeDialog: (state, action) => {
            state.refundReturnFeeModal = {
                id:action.payload.id,
                component: 'RefundReturnFee',
                type: 'new',
                props: {
                    isOpen: true
                },
                data: action.payload.data,
                customerOrder : action.payload.customerOrder,
                orderLineItems : action.payload.lists
            };
        },
        closeRefundReturnFeeDialog: (state, action) => {
            state.refundReturnFeeModal = {
                id:null,
                component: 'RefundReturnFee',
                type: 'new',
                props: {
                    isOpen: false
                },
                data: null,
                customerOrder : null,

            };
        },
        openImportRoyalmailTrackingDialog: (state, action) => {
            state.importRoyalmailTrackingDialog = {
                type: 'new',
                props: {
                    isOpen: true
                },
                data: null
            };
        },
        closeImportRoyalmailTrackingDialog: (state, action) => {
            state.importRoyalmailTrackingDialog = {
                type: 'new',
                props: {
                    isOpen: false
                },
                data: null
            };
        },
        setGojungoData: (state, action) => {
            state.gojungoData = action.payload.data;
            state.gojungoTableRow = action.payload.count;
        },
        setGojungoSettings: (state, action) => {
            state.gojungoSettings.channels = action.payload.channels;
            state.gojungoSettings.tenants = action.payload.tenants;
            state.gojungoSettings.currency = action.payload.currency;
            state.gojungoSettings.shipCountries = action.payload.shipCountries;
        },
        setEuData: (state, action) => {
            state.euData = action.payload.data;
            state.euTableRow = action.payload.count;
        },
    },
    extraReducers: {
        [getOrders.fulfilled]: ordersAdapter.setAll,
        // [updateStaff.fulfilled]: staffsAdapter.setAll
        // [deleteStaff.fulfilled]: staffsAdapter.removeOne,
    }
});

export const {
    setSettings,
    setOrderTrackingDetils,
    setTableRowCount,
    setOrderData,
    setFrasersReminders,
    setPendingReturnData,
    setCollabOrders,
    setCollabOrder,
    setCollabOrderData,
    setReturnData,
    setTrackingData,
    unSetTrackingData,
    openNewInvoiceDialog,
    setCheckoutTableRowCount,
    closeNewInvoiceDialog,
    openNewTrackingDialog,
    closeNewTrackingDialog,
    setOrderListPackQty,
    setReturnRequestData,
    setAlterationRequest,
    setAlterationRequestData,
    setCommissionData,
    setOrderFilter,
    openActionDialog,
    closeActionDialog,
    setCurrentDeliveryPartner,
    setCurrentDeliveryPartners,
    setCustomerReturnReasons,
    setRefundModal,
    setReturnOrderData,
    setRefundsData,
    openPickingTicketDialogs,
    setLatestPickingTickets, setRefundData, setReturnOrderFilter, setPendingReturnFilter, setReturnRestockFilter, setCollabOrderFilter,
    setAlterationRequestFilter,
    openAlterationTrackingDialog,
    setOrderStatusSummary,
    setDeclineSettings,
    setUnfulfillmentStatus,
    setInvoiceSalesReturnData,
    openOrderCancelDialog,
    closeOrderCancelDialog,
    openNewClaimOfferDialog,
    closeNewClaimOffeDialog,
    openRefundReturnFeeDialog,
    closeRefundReturnFeeDialog,
    setDpdManifestedErrorData,
    openImportRoyalmailTrackingDialog,
    closeImportRoyalmailTrackingDialog,
    setGojungoData,
    setGojungoSettings,
    setEuData,
} =
    orderSlice.actions;

export default orderSlice.reducer;
